import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function LifecycleOverview({
    open,
    onClose,
    setOpen,
}: ModalProps) {



    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Transition Details</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="status_detail_card">

                        {/* STATUS FLOW */}
                        <div className="status_flow">
                            <div className="status_item active">
                                <div className="icon">
                                    <CheckCircleIcon />
                                </div>
                                <span>Active</span>
                            </div>

                            <ArrowForwardIcon className="arrow" />

                            <div className="status_item suspended">
                                <div className="icon">
                                    <BlockIcon />
                                </div>
                                <span>Suspended</span>
                            </div>
                        </div>

                        {/* INFO GRID */}
                        <div className="info_grid">
                            <div className="info_box">
                                <label>Vendor</label>
                                <p>Fake Products Inc</p>
                            </div>

                            <div className="info_box">
                                <label>Triggered By</label>
                                <p>Manual</p>
                            </div>

                            <div className="info_box full">
                                <label>Date</label>
                                <p>12/20/2025, 12:34:16 AM</p>
                            </div>
                        </div>

                        {/* REASON */}
                        <div className="reason_box">
                            <label>Reason</label>
                            <p>Policy violation: Counterfeit products detected</p>
                        </div>

                    </div>

                </div>
            </div>
        </Modal>
    );
}
